module.exports = __webpack_public_path__ + "static/media/triangle-down-white.9d57ab1a.svg";